import { OneTickField } from "@codway-dev/ui";
import type { OneTickFieldStyles, OneTickFieldProps } from "@codway-dev/ui";

// ─── Faux form mock ──────────────────────────────────────────────────────────

function FieldPlaceholder({ height = 36 }: { height?: number }) {
  return (
    <div
      className="w-full rounded-md bg-gray-200/60"
      style={{ height: `${height}px` }}
    />
  );
}

// ─── Preview ─────────────────────────────────────────────────────────────────

const NOOP = () => {};

export interface OneTickEditorPreviewProps {
  textTemplate: OneTickFieldProps["textTemplate"];
  productTitle: string;
  priceLabel: string;
  description: string;
  imageUrl: string;
  textColor: string;
  descriptionColor: string;
  styles: OneTickFieldStyles;
}

export function OneTickEditorPreview({
  textTemplate,
  productTitle,
  priceLabel,
  description,
  imageUrl,
  textColor,
  descriptionColor,
  styles,
}: OneTickEditorPreviewProps) {
  return (
    <div className="sticky top-4">
      <s-box
        background="base"
        border="small subdued solid"
        borderRadius="large-100"
        padding="large-400"
      >
        <s-stack direction="block" gap="base">
          <s-stack direction="inline" gap="small-200" alignItems="center">
            <s-icon type="view" />
            <s-text type="strong">Vista previa:</s-text>
          </s-stack>

          <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
            <div className="text-center text-sm font-bold tracking-wide text-gray-800 mb-4">
              PAGO CONTRA REEMBOLSO
            </div>

            <div className="flex flex-col gap-3">
              <FieldPlaceholder height={48} />
              <FieldPlaceholder height={48} />
              <FieldPlaceholder height={48} />
              <FieldPlaceholder height={48} />

              <OneTickField
                textTemplate={textTemplate}
                productTitle={productTitle}
                priceLabel={priceLabel}
                description={description}
                imageUrl={imageUrl || undefined}
                textColor={textColor}
                descriptionColor={descriptionColor}
                styles={styles}
                selected={false}
                onToggle={NOOP}
              />

              <FieldPlaceholder height={40} />
            </div>
          </div>
        </s-stack>
      </s-box>
    </div>
  );
}
